import { FormSubmitStatuses, SubmitError } from '@web/forms/types';

/**
 * Utility wrapper for shopify/react-forms submit errors.
 * Pass a message (wrapped in gettext) and receive Promise with proper error format.
 */
export const getSubmitError = (message: string): Promise<SubmitError> => {
  const error: SubmitError = {
    status: FormSubmitStatuses.fail,
    errors: [
      {
        message,
      },
    ],
  };
  return Promise.resolve(error);
};
